<script>
  import { onMount, createEventDispatcher } from "svelte";
  import request from 'superagent';
  import { Route } from "tinro";
  import ChildMenu from './../../../../components/menu/ChildMenu.svelte';
  import DocumentForm from './form/Document.svelte';
  import { my_folders as default_folders_store, my_documents as documents_store } from './stores.js';
  
  const dispatch = createEventDispatcher();
  
  export let locale = 'cs';
  export let user = {};
  
  let folders = [];
  let documents = [];
  
  function getUser() {
    fetch(`/user.jsr`)
      .then(function(r) {
        if (r.ok) return r;
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        user = data.data[0]
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  
  
  
  onMount(() => {
    getUser()
    default_folder_store.subscribe(value => {
      if (value  != 'undefined' || !value)
        folders = value;
    });
    documents_store.subscribe(value => {
      if (value  != 'undefined' || !value)
        documents = value;
    });
  })
</script>
<nav class='navbar navbar-light bg-white justify-content-between shadow-sm'>
<ul class='nav flex-row'>
<li class='nav-item'>
<a class='nav-link' href='/' tinro-ignore title='Informační servis'>
<i class='fas fa-external-link-alt'></i>
Obsah
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/c' tinro-ignore title='Kalendář'>
<i class='far fa-calendar-alt'></i>
Kalendář
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/w' tinro-ignore title='Počasí ČR'>
<i class='wi wi-day-sunny-overcast'></i>
Počasí
</a>
</li>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/f' rel='nofollow' tinro-ignore title='Odběry novinek'>
<i class='fa fa-star'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-primary' href='/a' rel='nofollow' tinro-ignore title='Strojová analýza textového obsahu'>
<i class='fa fa-graduation-cap'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/nlp' rel='nofollow' tinro-ignore title='Tvorba analytických modelů'>
<i class='fa fa-chalkboard-teacher'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/kb' rel='nofollow' tinro-ignore title='Znalostní báze'>
<i class='fa fa-book'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/e' rel='nofollow' tinro-ignore title='Editor'>
<i class='fa fa-edit'></i>
</a>
</li>
{/if}
<li class='nav-item'>
<a class='nav-link' href='/info' rel='nofollow' tinro-ignore>
<i class='fa fa-info'></i>
</a>
</li>
</ul>
<ul class='nav flex-row'>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/profile' rel='nofollow' tinro-ignore title='Nastavení'>
<i class='fa fa-cog'></i>
</a>
</li>
{:else}
<li class='nav-item'>
<a class='nav-link text-primary' href='/html/account.html' rel='nofollow' tinro-ignore>Přihlášení</a>
</li>
{/if}
</ul>

</nav>
<div class='d-flex flex-row'>
<div class='row my-2 w-100'>
<Route path='/e'>
<div class='col-2'>
<div class='d-flex justify-content-between'>
<a class='btn btn-link text-primary'>
<i class='fa fa-folder-plus'></i>
</a>
</div>
<ChildMenu items='{folders}' url_prefix='{user ? '/e/my' : '/e'}/t'></ChildMenu>
</div>
<div class='col-10'>
<div class='d-flex justify-content-start'>
<a class='btn btn-link text-primary text-decoration-none' href='/e/my/d'>
<i class='fa fa-file-contract d-lg-none'></i>
<span class='d-none d-lg-inline'>
Nový dokument
</span>
</a>
</div>
<div class='list-group-items'>
{#each documents as {id, title, about}}
<li class='list-group-item'>
<h3>
<a href='/e/my/d/{id}'>{title}</a>
</h3>
<div class='text-muted'>{about}</div>
</li>
{/each}
</div>
</div>
</Route>
<Route path='/e/my/d'>
<DocumentForm locale='{locale}'></DocumentForm>
</Route>
<Route path='/e/my/d/:document_id'>
<DocumentForm document_id='{params.document_id}' locale='{locale}'></DocumentForm>
</Route>
</div>
</div>
